import React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Tooltip from '../../common/Tooltip';
import { useCurrentBoardState } from '../../../services/state';

const ZoomSettings = () => {
  const boardState = useCurrentBoardState();
  const allowZoomToCircle = boardState.allowZoomToCircle.get();

  return (
    <ButtonGroup color="menuActive" sx={{ marginRight: '2rem' }}>
      <Tooltip title="Zoom only groups">
        <Button onClick={() => boardState.merge({ allowZoomToCircle: false })}>
          <ZoomGroupIcon color={allowZoomToCircle ? '#fff' : '#7858FB'} />
        </Button>
      </Tooltip>
      <Tooltip title="Allow zooming in on circles">
        <Button onClick={() => boardState.merge({ allowZoomToCircle: true })}>
          <ZoomCircleIcon color={allowZoomToCircle ? '#7858FB' : '#fff'} />
        </Button>
      </Tooltip>
    </ButtonGroup>
  );
};

export default ZoomSettings;

const ZoomCircleIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8.5" cy="8.5" r="7.5" stroke={color} strokeWidth="2" />
    <circle cx="7.5" cy="7.5" r="4" fill={color} stroke={color} />
    <rect
      x="13.0755"
      y="14.3155"
      width="2"
      height="14.1"
      rx="1"
      transform="rotate(-44 13.0755 14.3155)"
      fill={color}
    />
  </svg>
);

const ZoomGroupIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8.5" cy="8.5" r="7.5" stroke={color} strokeWidth="2" />
    <circle cx="7.5" cy="7.5" r="4" stroke={color} />
    <rect
      x="13.0755"
      y="14.3155"
      width="2"
      height="14.1"
      rx="1"
      transform="rotate(-44 13.0755 14.3155)"
      fill={color}
    />
  </svg>
);
